import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { UnifiedAuthService } from './auth.service';
import { BehaviorSubject, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private prefix = "ankarauniversitesi";
  private appCode = "au_mobile";

  constructor(private http: HttpClient,private loginservice: UnifiedAuthService) { fromEvent(window, 'resize').subscribe(() => {
      this.isMobileSubject.next(
        window.innerWidth <= this.mobileBreakpoint
      );
    });}

  private readonly mobileBreakpoint = 768;

  private isMobileSubject = new BehaviorSubject<boolean>(
    window.innerWidth <= this.mobileBreakpoint
  );

  isMobile$ = this.isMobileSubject.asObservable();



  get isMobile(): boolean {
    return window.innerWidth <= this.mobileBreakpoint;
  }

  /** 📱 Yeni Device ID üret */
  generateDeviceId(ogrenciNo: string): string {
    const uniqueId = uuidv4();
    return `${this.prefix}-${this.appCode}-${ogrenciNo}-${uniqueId}`;
  }

  /** 📌 LocalStorage’den Device ID getir */
  getLocalDeviceId(): string | null {
    try {
      return localStorage.getItem('device_id');
    } catch (e) {
      console.error("🔥 Hata (getLocalDeviceId): ", e);
      return null;
    }
  }

    getServerDeviceId(): string | null {
    try {
      const serverdevice= localStorage.getItem('userList') ? JSON.parse(localStorage.getItem('userList') || '{}').data.slice(-1)[0].deviceId : null;
      return serverdevice;
    } catch (e) {
      console.error("🔥 Hata (getLocalDeviceId): ", e);
      return null;
    }
  }

  /** 🗑 Device ID tamamen sil + backend’den sil */
deleteDeviceId(): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      const storedId = localStorage.getItem('device_id');

      if (!storedId) {
        console.warn("⚠️ Silinecek Device ID yok");
        return resolve(false);
      }

   //   console.log("🗑️ Device ID siliniyor...");

      this.http.get(`Yoklama/DeleteDevice?deviceId=${storedId}`)
        .subscribe({
          next: (res: any) => {
            if (res?.success) {
            //   console.log("✅ Server'dan Device ID silindi");

              // Local sil
              localStorage.removeItem('device_id');

              return resolve(true);
            } else {
              console.error("❌ Server silemedi:", res?.message);
              return resolve(false);
            }
          },
          error: (err) => {
            console.error("🔥 Server hata:", err);
            return resolve(false);
          }
        });

    } catch (e) {
      console.error("🔥 Hata (deleteDeviceId):", e);
      return resolve(false);
    }
  });
}


  /** 💾 Kayıt yoksa kaydet, varsa güncelle */
  saveOrUpdateDeviceId(newDeviceId: string): boolean {
    try {
      const existing = localStorage.getItem('device_id');

      if (!existing) {
        console.log("✅ Yeni Device ID kaydedildi:", newDeviceId);
      } else {
        console.log("🔄 Device ID güncellendi:", newDeviceId);
      }

      localStorage.setItem('device_id', newDeviceId);

      return true;

    } catch (e) {
      console.error("🔥 Hata (saveOrUpdateDeviceId):", e);
      return false;
    }
  }

  /** 🔍 Server Device ID ile local karşılaştır */
  checkDeviceRegistered(serverDeviceId: string): boolean {
    try {
      const localDeviceId = localStorage.getItem('device_id');

    //   console.log("📱 Local DeviceID:", localDeviceId);
     //  console.log("🌐 Server DeviceID:", serverDeviceId);

      if (!localDeviceId) {
        console.warn("⚠️ Local cihaz kaydı yok");
        return false;
      }

      if (localDeviceId === serverDeviceId) {
        // console.log("✅ Cihazlar aynı");
        return true;
      } else {
        console.error("❌ Cihazlar farklı");
        return false;
      }

    } catch (e) {
      console.error("🔥 Hata (checkDeviceRegistered):", e);
      return false;
    }
  }
}
